/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_4_AInputs */

const en_cp_faq_4_a = /** @type {(inputs: Cp_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, as a monitoring instrument and process evidence. Credit policy stays with the campus; for Campus Partners we help with the supporting paperwork.`)
};

const id_cp_faq_4_a = /** @type {(inputs: Cp_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa sebagai instrumen pemantauan dan bukti proses. Kebijakan konversi SKS tetap milik kampus; untuk Kampus Mitra kami bantu dokumen pendukungnya.`)
};

/**
* | output |
* | --- |
* | "Yes, as a monitoring instrument and process evidence. Credit policy stays with the campus; for Campus Partners we help with the supporting paperwork." |
*
* @param {Cp_Faq_4_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_4_a = /** @type {((inputs?: Cp_Faq_4_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_4_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_4_a(inputs)
	return en_cp_faq_4_a(inputs)
});